// extracted by mini-css-extract-plugin
module.exports = {"li":"post_link-module--li--1Uje8","link":"post_link-module--link--1gOvS","date":"post_link-module--date--hI5Fk","h3":"post_link-module--h3--1U3V5"};